import { render } from "./AdvanceBudgetsPage.vue?vue&type=template&id=ff9a1a8c&scoped=true"
import script from "./AdvanceBudgetsPage.vue?vue&type=script&lang=js"
export * from "./AdvanceBudgetsPage.vue?vue&type=script&lang=js"

import "./AdvanceBudgetsPage.vue?vue&type=style&index=0&id=ff9a1a8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff9a1a8c"]])

export default __exports__